(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8005],{

/***/ 90695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ subscribeInsetSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var subscribeInsetSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SUBSCRIBE */ .Z.SUBSCRIBE).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function subscribeInsetSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 57416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64384);
/* harmony import */ var _api_baskets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18682);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8025);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68866);
/* harmony import */ var _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43181);
/* harmony import */ var _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4557);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48106);
/* harmony import */ var _SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74971);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81628);
/* harmony import */ var _common_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11769);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

















var SingleProduct = function(param) {
    var product1 = param.product, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, _$addToCart = param.addToCart, addToWishlist = param.addToWishlist, _$openQuickView = param.openQuickView, _$increaseCnt = param.increaseCnt, _$showToastAlert = param.showToastAlert, _$insertBasketsAction = param.insertBasketsAction, _$fetchBasketsAction = param.fetchBasketsAction, dummyList = param.dummyList, addCart = param.addCart, inCart = param.inCart, index = param.index;
    var inBasket = inCart ? inCart(product1) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
        return basketsItem.pcode === product1.pcode;
    })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
        return cartItem.pcode === product1.pcode;
    }));
    // orderType 이 'O' 이거나 없으면 일반 구매 가능 상품
    var isOrderTypeO = !product1.orderType || product1.orderType === "O";
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장바구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product1.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_11__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Wrapper */ .im, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                                onClick: moveToDetail,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    src: product1.main_image,
                                    alt: product1.pname || "\uC0C1\uD488 \uC774\uBBF8\uC9C0",
                                    layout: "fill",
                                    objectFit: "cover",
                                    sizes: "(max-width: 768px) 100vw, 33vw",
                                    priority: index === 0
                                })
                            })
                        }),
                        product1.sfnz_view === "Y" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .SfnzBadge */ .L4, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png",
                                alt: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uCE5C\uD658\uACBD \uBC30\uC9C0"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductContentWrapper */ .ZD, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductName */ .rZ, {
                                onClick: moveToDetail,
                                children: product1.pname
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductBottomWrapper */ .qW, {
                            children: [
                                isOrderTypeO && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceWrapper */ .vN, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceBox */ .bz, {
                                        children: [
                                            product1.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                        children: [
                                                            product1.salePer,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product1.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.price), "\uC6D0")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "d-flex",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h5", {
                                                    children: [
                                                        (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.discount_price),
                                                        "\uC6D0"
                                                    ]
                                                })
                                            }),
                                            Number(product1.quantity) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    fontSize: "14px"
                                                },
                                                children: [
                                                    "\uAC1C\uB2F9",
                                                    " ",
                                                    (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(Math.floor(Number(product1.discount_price) / Number(product1.quantity))),
                                                    "\uC6D0"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                product1.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "\uD488\uC808"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: isOrderTypeO && (!inBasket ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "mobonCart",
                                        onClick: function() {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-add"
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        onClick: function() {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-check"
                                        })
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .StickerWrapper */ .Mo, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ViewBox */ .HA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)((0,_common_helper__WEBPACK_IMPORTED_MODULE_13__/* .calcProdPoint */ .tB)((Number(String(product1.discount_price).replace(/[^\d.-]/g, "")) || 0) * 1)),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Sticker */ .My, {
                                                children: "P"
                                            }),
                                            " \uC801\uB9BD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-view.png",
                                                alt: "\uC870\uD68C\uC218 \uC544\uC774\uCF58"
                                            }),
                                            product1.hit
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__/* .addToCart */ .Xq,
    openQuickView: _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_15__/* .openQuickView */ .$,
    increaseCnt: _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__/* .increaseCnt */ .us,
    showToastAlert: _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__/* .showToastAlert */ .I,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el,
    fetchBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .fetchBasketsAction */ .Ei
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(SingleProduct));


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    width: fit-content;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 90vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    & h5 {\n      font-size: 18px;\n      margin: 15px 0px;\n      & pre {\n        overflow: visible !important;\n        text-align: center;\n      }\n      @media (max-width: 575px) {\n        font-size: 1rem;\n      }\n    }\n    & img {\n      width: 75%;\n    }\n\n    & a {\n      margin-top: 20px;\n      width: 200px;\n    }\n\n    @media (max-width: 991px) {\n      & a {\n        width: 150px;\n      }\n    }\n    @media (max-width: 767px) {\n      & a {\n        width: 130px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-751e3b31-0"
})(_templateObject());
var InquiryCompleteModal = function(param) {
    var onClickInquiryComplete = param.onClickInquiryComplete, confirmText = param.confirmText, confirmImg = param.confirmImg;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiryComplete();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: confirmImg || "/assets/imgs/page/common/inquiry_complete_icon.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: confirmText || "\uC18C\uC911\uD55C \uC815\uBCF4 \uAC10\uC0AC\uD569\uB2C8\uB2E4!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn",
                            onClick: onClickInquiryComplete,
                            children: "\uC644\uB8CC"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquiryCompleteModal);


/***/ }),

/***/ 18005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Esg_guide_post; }
});

// UNUSED EXPORTS: CheckoutBtn

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/esg-guide/post/Esg-guide-post-styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  .text-body {\n    :hover {\n      border-bottom: 1px solid;\n    }\n  }\n  & h1 {\n    word-break: keep-all;\n    @media screen and (max-width: 991px) {\n      font-size: 42px;\n    }\n    @media screen and (max-width: 767px) {\n      font-size: 36px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  .entry-meta {\n    width: 100%;\n    font-size: 0.9rem;\n    display: flex;\n    justify-content: space-between;\n  }\n  .meta-left {\n    display: flex;\n    align-items: center;\n  }\n  .meta-right {\n    display: flex;\n    align-items: center;\n    & li {\n      cursor: pointer;\n      color: #6c757d !important;\n      :hover {\n        color: #198754 !important;\n      }\n    }\n    & li:not(:last-of-type) {\n      margin-right: 10px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  .single-excerpt {\n    word-break: keep-all;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 400px;\n  max-height: 600px;\n  border-radius: 30px;\n  background: center / contain no-repeat url(",
        ");\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n\n  @media screen and (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media screen and (max-width: 991px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media screen and (max-width: 575px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b579d0-0"
})(_templateObject());
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b579d0-1"
})(_templateObject1());
var HeaderMeta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b579d0-2"
})(_templateObject2());
var ContentsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b579d0-3"
})(_templateObject3());
var Thumbnail = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-70b579d0-4"
})(_templateObject4(), function(props) {
    return props.thumbnail;
});
var EditorWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b579d0-5"
})(_templateObject5());
var RecomandList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b579d0-6"
})(_templateObject6());

// EXTERNAL MODULE: ./node_modules/react-quill/dist/quill.bubble.css
var quill_bubble = __webpack_require__(89961);
// EXTERNAL MODULE: ./node_modules/react-quill/dist/quill.snow.css
var quill_snow = __webpack_require__(80091);
// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./components/newsletter/newsletter.styles.js
var newsletter_styles = __webpack_require__(80391);
// EXTERNAL MODULE: ./api/subscribe.js
var api_subscribe = __webpack_require__(90695);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
;// CONCATENATED MODULE: ./components/esg-guide/post/Esg-guide-post.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Esg_guide_post_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function Esg_guide_post_templateObject() {
    var data = Esg_guide_post_taggedTemplateLiteral([
        "\n  margin: 0 15px 0 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #3bb77e;\n  background-color: #3bb77e;\n  color: #fff;\n  border-radius: 5px;\n  word-break: keep-all;\n  font-size: 1rem;\n  font-weight: 500;\n\n  :hover {\n    background-color: #ffc107;\n    border-color: #ffc107;\n  }\n"
    ]);
    Esg_guide_post_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var CheckoutBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-617fd1e6-0"
})(Esg_guide_post_templateObject());
var DummyBoardsCategory = {
    news: "ESG \uD658\uACBD\uB274\uC2A4",
    letter: "ESG \uB274\uC2A4\uB808\uD130",
    package: "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC",
    make: "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0",
    notice: "\uACF5\uC9C0\uC0AC\uD56D"
};
var Post = function(param) {
    var initialPostData = param.initialPostData, postId = param.postId;
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(initialPostData.current || {}), postData = ref6[0];
    var ref1 = (0,react.useState)(initialPostData.next || {}), postNextData = ref1[0];
    var ref2 = (0,react.useState)(initialPostData.prev || {}), postPrevData = ref2[0];
    var allPosts = react.useMemo(function() {
        var posts = [];
        // 이전 게시물들 추가 (배열)
        if (Array.isArray(postPrevData) && postPrevData.length > 0) {
            postPrevData.forEach(function(prevPost) {
                if (prevPost && prevPost.id) {
                    posts.push(_objectSpread({}, prevPost, {
                        isPrev: true
                    }));
                }
            });
        }
        // 다음 게시물들 추가 (배열)
        if (Array.isArray(postNextData) && postNextData.length > 0) {
            postNextData.forEach(function(nextPost) {
                if (nextPost && nextPost.id) {
                    posts.push(_objectSpread({}, nextPost, {
                        isNext: true
                    }));
                }
            });
        }
        return posts;
    }, [
        postPrevData,
        postNextData
    ]);
    var ref3 = (0,react.useState)(""), email = ref3[0], setEmail = ref3[1];
    var ref4 = (0,react.useState)(false), openInquiryComplete = ref4[0], setOpenInquiryComplete = ref4[1];
    var onChangeEmail = function(e) {
        setEmail(e.target.value);
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    var getBackUrl = function(gubun) {
        if (gubun === "notice") return "/csboard/notice";
        if (gubun === "news") return "/esg-guide/news";
        if (gubun === "letter") return "/esg-guide/letter";
        if (gubun === "package" || gubun === "make") return "/esg-guide/blog/".concat(gubun);
        return "/";
    };
    var subscribe = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(email == "")) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        body = {
                            modes: "InsertSet",
                            email: email
                        };
                        _ctx.next = 6;
                        return (0,api_subscribe/* subscribeInsetSet */.Y)(body);
                    case 6:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            onClickInquiryComplete();
                            (0,common_alert/* successAlert */.Cq)((res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uAD6C\uB3C5 \uC2E0\uCCAD\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            setEmail("");
                        } else {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref5 = res.Data) === null || ref5 === void 0 ? void 0 : ref5.Msg) || "\uAD6C\uB3C5 \uC2E0\uCCAD\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function subscribe() {
            return _ref.apply(this, arguments);
        };
    }();
    var isEsgGuide = router.asPath.includes("esg-guide");
    // 페이지 유형에 따라 브레드크럼 데이터 구성
    var breadcrumbData = isEsgGuide ? {
        parent: "\uD648",
        sub: "ESG\uC790\uB8CC\uC2E4",
        subTitle: DummyBoardsCategory[postData.gubun],
        subChild: postData === null || postData === void 0 ? void 0 : postData.title
    } : {
        parent: "\uD648",
        sub: DummyBoardsCategory[postData.gubun],
        subTitle: postData === null || postData === void 0 ? void 0 : postData.title,
        subChild: undefined
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, _objectSpread({}, breadcrumbData, {
                pageTitle: postData === null || postData === void 0 ? void 0 : postData.title,
                pageDesc: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ESG\uC790\uB8CC\uC2E4\uC5D0\uC11C \uC9C0\uC18D\uAC00\uB2A5\uD55C \uD328\uD0A4\uC9D5\uACFC \uD658\uACBD \uAD00\uB828 \uCD5C\uC2E0 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uC138\uC694. \uCE5C\uD658\uACBD \uD328\uD0A4\uC9D5 \uD2B8\uB80C\uB4DC\uC640 \uC815\uCC45 \uC18C\uC2DD\uC744 \uD55C\uB208\uC5D0 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                pageKeyword: "ESG\uC790\uB8CC\uC2E4, \uCE7C\uB81B\uC2A4\uD1A0\uC5B4, \uC9C0\uC18D\uAC00\uB2A5\uACBD\uC601, \uCE5C\uD658\uACBD\uC815\uBCF4, \uD328\uD0A4\uC9D5\uD2B8\uB80C\uB4DC, \uD658\uACBD\uC815\uCC45, ESG\uACBD\uC601, \uCE5C\uD658\uACBD\uC18C\uC2DD, \uC9C0\uC18D\uAC00\uB2A5\uD328\uD0A4\uC9D5",
                id: postId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "mb-50",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container custom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-12 m-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                                className: "single-page pt-50 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, {
                                        className: "single-header style-2 mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-xl-10 col-lg-12 m-auto border-bottom",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            className: "mb-30 text-center",
                                                            children: postData === null || postData === void 0 ? void 0 : postData.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMeta, {
                                                            className: "single-header-meta mb-10",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "entry-meta meta-1 mt-10 mb-10",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "meta-left",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "#",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    className: "author-avatar",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        className: "img-circle",
                                                                                        src: "/favicon.svg",
                                                                                        alt: "favicon",
                                                                                        style: {
                                                                                            width: "30px"
                                                                                        }
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "post-by",
                                                                                children: "By \uCE7C\uB81B\uC2A4\uD1A0\uC5B4"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "post-on has-dot",
                                                                                children: postData === null || postData === void 0 ? void 0 : postData.wdate
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                        className: "meta-right",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                "aria-label": "Share",
                                                                                className: "action-btn hover-up",
                                                                                onClick: function() {
                                                                                    return navigator.clipboard.writeText(globalThis.location.href).then(function() {
                                                                                        return (0,common_alert/* successAlert */.Cq)("\uB9C1\uD06C\uAC00 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                                                                                    });
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fi-rs-share",
                                                                                    style: {
                                                                                        fontSize: "20px",
                                                                                        marginRight: "16px"
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: getBackUrl(postData.gubun),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        children: "\uBAA9\uB85D\uC73C\uB85C"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                ((postData === null || postData === void 0 ? void 0 : postData.file1) || (postData === null || postData === void 0 ? void 0 : postData.file2) || (postData === null || postData === void 0 ? void 0 : postData.file3)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xl-10 col-lg-12 m-auto border-bottom p-3 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center flex-wrap",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "me-2",
                                                                children: "\uCCA8\uBD80\uD30C\uC77C :"
                                                            }),
                                                            (postData === null || postData === void 0 ? void 0 : postData.file1) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "me-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        className: "text-body",
                                                                        target: "_blank",
                                                                        href: postData === null || postData === void 0 ? void 0 : postData.file1,
                                                                        children: (postData === null || postData === void 0 ? void 0 : postData.file1_name) || "\uCCA8\uBD80\uD30C\uC77C 1"
                                                                    }),
                                                                    (postData === null || postData === void 0 ? void 0 : postData.file2) && ","
                                                                ]
                                                            }),
                                                            (postData === null || postData === void 0 ? void 0 : postData.file2) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "me-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        className: "text-body",
                                                                        target: "_blank",
                                                                        href: postData === null || postData === void 0 ? void 0 : postData.file2,
                                                                        children: (postData === null || postData === void 0 ? void 0 : postData.file2_name) || "\uCCA8\uBD80\uD30C\uC77C 2"
                                                                    }),
                                                                    (postData === null || postData === void 0 ? void 0 : postData.file3) && ","
                                                                ]
                                                            }),
                                                            (postData === null || postData === void 0 ? void 0 : postData.file3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "text-body",
                                                                    target: "_blank",
                                                                    href: postData === null || postData === void 0 ? void 0 : postData.file3,
                                                                    children: (postData === null || postData === void 0 ? void 0 : postData.file3_name) || "\uCCA8\uBD80\uD30C\uC77C 3"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsWrapper, {
                                        className: "single-content mt-30 mb-40",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xl-10 m-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorWrapper, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "ck-content",
                                                            dangerouslySetInnerHTML: {
                                                                __html: postData === null || postData === void 0 ? void 0 : postData.contents
                                                            }
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-lg-10 col-xl-10 m-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                className: "text-lg font-medium text-center mb-4 entry-bottom pt-45",
                                                children: [
                                                    "'",
                                                    (postData === null || postData === void 0 ? void 0 : postData.gubun) && DummyBoardsCategory[postData.gubun] || "\uADF8\uB9B0 \uC5EC\uC815(\u65C5\u884C)",
                                                    "'\uC758 \uB2E4\uB978 \uAE00"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "rounded overflow-hidden mb-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                                    className: "w-full",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                        children: allPosts.map(function(post) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                className: "border-b border-gray-200 hover:bg-gray-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-left",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "d-flex gap-2",
                                                                            children: [
                                                                                post.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "min-w-[42px] max-w-[42px]",
                                                                                    style: {
                                                                                        width: "42px",
                                                                                        marginTop: "1%"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: post.thumbnail,
                                                                                        alt: post.title,
                                                                                        className: "w-full h-auto object-cover rounded"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "pt-5",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            href: "/esg-guide/post/".concat(post.id),
                                                                                            className: "hover:text-blue-500 font-md truncate",
                                                                                            children: post.title
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            className: "text-left font-sm truncate",
                                                                                            children: post.summary
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-center text-gray-500 whitespace-nowrap w-[120px]",
                                                                        children: post.wdate
                                                                    })
                                                                ]
                                                            }, post.id);
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tags w-sm-100 mb-30 d-flex justify-content-center align-items-center gap-4",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mx-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutBtn, {
                                                        onClick: function() {
                                                            router.push(getBackUrl(postData.gubun));
                                                        },
                                                        children: "\uBAA9\uB85D\uC73C\uB85C"
                                                    })
                                                })
                                            }),
                                            (postData === null || postData === void 0 ? void 0 : postData.gubun) && postData.gubun === "letter" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsletter_styles/* Section */.$0, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                        children: [
                                                            "\uCD5C\uC2E0 \uD658\uACBD\uC815\uCC45\uACFC \uD3EC\uC7A5\uC7AC \uD2B8\uB80C\uB4DC, ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 \uC2E0\uC81C\uD488 \uCD9C\uC2DC \uC18C\uC2DD\uC744 \uAC00\uC7A5 \uBA3C\uC800 \uBC1B\uC544\uBCF4\uC138\uC694!"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/page/subscribe/icon.png",
                                                        alt: "newsletter_btn",
                                                        className: "icon",
                                                        style: {
                                                            right: "30px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsletter_styles/* SubscibeWrapper */.yc, {
                                                        esg: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                onChange: onChangeEmail,
                                                                type: "text",
                                                                placeholder: "\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694",
                                                                value: email || ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                onClick: subscribe,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/imgs/page/subscribe/subscribe_btn.png"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (postData === null || postData === void 0 ? void 0 : postData.products) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "section-title style-1 mb-30 mt-50",
                                                        children: "\uC5F0\uAD00 \uC0C1\uD488"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecomandList, {
                                                        className: "product-grid-4",
                                                        children: postData.products.map(function(product, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                                                product: product,
                                                                index: i
                                                            }, i);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })),
            openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                onClickInquiryComplete: onClickInquiryComplete
            })
        ]
    });
};
/* harmony default export */ var Esg_guide_post = (Post);


/***/ }),

/***/ 80391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "DK": function() { return /* binding */ SubscibeInput; },
/* harmony export */   "OP": function() { return /* binding */ TextWrapper; },
/* harmony export */   "Sl": function() { return /* binding */ SubscibeContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "wz": function() { return /* binding */ SubscibeButton; },
/* harmony export */   "yc": function() { return /* binding */ SubscibeWrapper; }
/* harmony export */ });
/* unused harmony export StyledLink */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 230px;\n  background-color: #f4f4f4;\n  overflow-x: hidden;\n  @media (max-width: 1199px) {\n    .icon {\n      right: 10%;\n    }\n  }\n  @media (max-width: 991px) {\n    padding: 42px;\n  }\n  @media (max-width: 767px) {\n    padding: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  text-align: left;\n\n  @media (max-width: 767px) {\n    text-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 34px;\n  margin-bottom: 20px;\n  min-width: 250px;\n\n  span {\n    color: #3bb77e;\n  }\n  @media (max-width: 991px) {\n    font-size: 24px;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n    margin-bottom: 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 14px;\n  gap: 30px;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n   {\n    flex: 1;\n    height: 50px;\n    border: none;\n    outline: none;\n    padding: 0 12px;\n    font-size: 16px;\n    background-color: white;\n       \n    @media (max-width: 767px) {\n    padding: 10px 12px;\n    width: 100%;\n    margin-bottom: 15px;\n  }\n       \n   @media (max-width: 575px) {\n   padding: 10px 12px;\n   width: 100%;\n   margin-bottom: 15px;\n   }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "{\n    height: 50px;\n    padding: 0 16px;\n    border: none;\n    border-radius: 10px;\n    background-color: #3bb77e;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:hover {\n      background-color: #349b6c;\n    }\n\n    @media (max-width: 767px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  color: #666;\n  margin-top: 10px;\n\n  @media (max-width: 767px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: bold;\n  text-decoration: underline;\n  color: #3bb77e;\n  margin-top: 10px;\n\n  &:hover {\n    color: #349b6c;\n  }\n\n  @media (max-width: 767px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-fb34d78a-0"
})(_templateObject());
var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-fb34d78a-1"
})(_templateObject1());
var TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb34d78a-2"
})(_templateObject2());
// h3 스타일
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-fb34d78a-3"
})(_templateObject3());
var SubscibeContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb34d78a-4"
})(_templateObject4());
var SubscibeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb34d78a-5"
})(_templateObject5());
var SubscibeInput = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-fb34d78a-6"
})(_templateObject6());
var SubscibeButton = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-fb34d78a-7"
})(_templateObject7());
// Paragraph 스타일
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-fb34d78a-8"
})(_templateObject8());
// Link 스타일
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-fb34d78a-9"
})(_templateObject9());


/***/ }),

/***/ 43181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ openQuickView; },
/* harmony export */   "z": function() { return /* binding */ closeQuickView; }
/* harmony export */ });
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var openQuickView = function(product) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .OPEN_QUICK_VIEW */ .GS,
            payload: {
                product: product
            }
        });
    };
};
var closeQuickView = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE_QUICK_VIEW */ .fJ
        });
    };
};


/***/ }),

/***/ 89961:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 80091:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);